export function handleFileChange(data, callback, section) {
  const { file, field } = data;
  if (file) {
    const reader = new FileReader();
    reader.readAsDataURL(file[0]);
    reader.onloadend = () => {
      if (file[0].type == 'application/pdf' && file[0].size > 2000000) {
        fetch(reader.result)
          .then(res => res.blob())
          .then(blob => {
            const file = window.URL.createObjectURL(blob);
            return callback({
              section,
              data: { value: file, key: field },
              uri: reader.result,
            });
          });
      }
      return callback({
        section,
        data: { value: reader.result, key: field },
      });
    };
  }
  return callback({ section, data: { value: undefined, key: field } });
}
